<template>
  <div class="wave-container">
    <transition name="fade">
      <div class="wave-bar">
        <span
          class="wave"
          :style="{ transform: `scaleY(${wave / 100})` }"
        ></span>
      </div>
    </transition>
    <img src="../../images/microphone.png" alt="" class="wave-img" />
  </div>
</template>

<script>
export default {
  props: {
    wave: {
      type: Number,
      default: 0,
    },
  },
}
</script>
<style lang="stylus" scoped>
.wave-container
  position absolute
  width 18px
  height 35px
  bottom 30px
  left 50px
  .wave-img
    width 100%
    height 100%
  .wave-bar
    position absolute
    bottom 10px
    left 3px
    width 12px
    height 25px
    border-radius 25px
    z-index 10
    display: flex
    font-size: 0
    .wave
      position: absolute
      bottom 0
      left 0
      display: inline-block
      width 12px
      height: 100%
      border-radius 25px
      background-color #f6a400
      transition  0.01s
      transform: scaleY(0)
      transform-origin:left bottom
</style>
